import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import Signin from "pages/auth/signin";
import "assets/scss/style.scss";
import CMSHome from "pages/CMS/CMShome";
import AdminHome from "pages/superadmin/adminHome";
import PrivateRoute from "components/shared/PrivateRoute";
import TrekCMS from "pages/CMS/segments/trek";
import TourCMS from "pages/CMS/segments/tour";
import TravelCMS from "pages/CMS/segments/travel";
import Notification from "pages/CMS/common/notification";
import ImageGallery from "pages/CMS/segments/imagesGallery";
import YoutubeVideos from "pages/CMS/segments/youtubeVideos";
import UpcomingEvents from "pages/CMS/segments/upcomingEvents";
import AppearanceCMS from "pages/CMS/segments/appearance";
import TrekEditDetails from "pages/CMS/common/editDetails/TrekEditDetails";
import TrashBox from "components/shared/Trash";
import Enquiry from "components/shared/Enquiry";
import TravelEditdetails from "pages/CMS/common/editDetails/TravelEditDetails";
import RollManager from "pages/CMS/segments/RollManager";
import RoleProfile from "pages/CMS/segments/RoleProfile";
import SeoCMS from "pages/CMS/segments/seo";
import CategoriesCMS from "pages/CMS/segments/categories";
import { ToastHost } from "components/shared/Toast";
import ProfilePage from "pages/profile";

function App() {
  const { loading } = useSelector((state) => state.auth);

  return (
    <Router>
      <ToastHost />
      <Routes>
        <Route path="/" element={loading ? <p>Loading...</p> : <Signin />} />
        <Route path="/subAdmin" element={<Signin />} />
        <Route path="/editor" element={<Signin />} />
        <Route path="/subAdmin/login" element={<Signin />} />
        <Route path="/editor/login" element={<Signin />} />
        <Route path="/dashboard" element={<PrivateRoute element={<AdminHome />} />} />
        <Route path="/cms" element={<PrivateRoute element={<CMSHome />} />} />
        <Route path="/cms/seo" element={<PrivateRoute element={<SeoCMS />} />} />
        <Route path="/cms/seo/:pageId" element={<PrivateRoute element={<SeoCMS />} />} />
        <Route path="/cms/categories" element={<PrivateRoute element={<CategoriesCMS />} />} />
        <Route path="/cms/trek/*" element={<PrivateRoute element={<TrekCMS />} />} />
        <Route path="/cms/tour" element={<PrivateRoute element={<TourCMS />} />} />
        <Route path="/cms/travel/*" element={<PrivateRoute element={<TravelCMS />} />} />
        <Route path="/cms/travel/editdetails/:slug/:form?" element={<PrivateRoute element={<TravelEditdetails />} />} />
        <Route path="/cms/travel/editDetails/:slug/:form?" element={<PrivateRoute element={<TravelEditdetails />} />} />
        <Route path="/cms/trek/editdetails/:slug/:form?" element={<PrivateRoute element={<TrekEditDetails />} />} />
        <Route path="/cms/trek/editDetails/:slug/:form?" element={<PrivateRoute element={<TrekEditDetails />} />} />
        <Route path="/cms/image-gallery/*" element={<PrivateRoute element={<ImageGallery />} />} />
        <Route path="/cms/youtube-video" element={<PrivateRoute element={<YoutubeVideos />} />} />
        <Route path="/cms/upcoming-event" element={<PrivateRoute element={<UpcomingEvents />} />} />
        <Route path="/cms/appearance" element={<PrivateRoute element={<AppearanceCMS />} />} />
        <Route path="/cms/trash" element={<PrivateRoute element={<TrashBox />} />} />
        <Route path="/cms/notification" element={<PrivateRoute element={<Notification />} />} />
        <Route path="/enquiry" element={<PrivateRoute element={<Enquiry />} />} />
        <Route path="/roleManager" element={<PrivateRoute element={<RollManager />} />} />
        <Route path="/roleManager/profile/:id" element={<PrivateRoute element={<RoleProfile />} />} />
        <Route path="/profile" element={<PrivateRoute element={<ProfilePage />} />} />
      </Routes>
    </Router>
  );
}

export default App;
